import { preventSkip, populateTCPAField } from '../../../helpers';

export function nextButtonClickCallBack(e) {
	e.stopPropagation();
	populateTCPAField();
	preventSkip(e);
}
